import { ReactElement } from 'react';

export enum TourType {
    INITIAL_STEP = 'INITIAL_STEP',
    ZOOM_IN_ZOOM_OUT = 'ZOOM_IN_ZOOM_OUT',
    STATION_AND_DRAWERS = 'STATION_AND_DRAWERS',
    INFO_ABOUT_STATIONS = 'INFO_ABOUT_STATIONS',
    INFO_ABOUT_LEGENEDS = 'INFO_ABOUT_LEGENEDS',
    INFO_ABOUT_PATHS = 'INFO_ABOUT_PATHS',
    TRANSITION_ZONE = 'TRANSITION_ZONE',
    PLAN_UR_LIFE = 'PLAN_UR_LIFE'
}

export type TourStep = {
    title: string;
    content: ReactElement | string;
    primaryBtnLabel?: string;
    type: TourType;
};
